export default "__VITE_ASSET__DzhH_sW9__"